import Navbar from "./Navbar";

export default function Frame({ children, menuOpen, onToggleMenu, onCloseMenu, page = "", theme = "dark", onToggleTheme }) {
  return (
    <div className="frame">
      {/* Navbar pinned to top */}
      <Navbar menuOpen={menuOpen} onToggle={onToggleMenu} onClose={onCloseMenu} theme={theme} onToggleTheme={onToggleTheme} />

      {/* Scrollable viewport — holds all page content */}
      <div className={`frame-viewport${page ? ` frame-viewport--${page}` : ""}`}>{children}</div>

      {/* Border overlay with corner ticks — sits on top */}
      <div className="frame-border" aria-hidden="true" />

      {/* Bottom status bar — retro terminal */}
      <span className="frame-info-left">main* — utf-8 — amoled</span>
      <span className="frame-info">● online — 60fps</span>
    </div>
  );
}
